import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { isUseCase } from '@/lib/utils'

import { SearchSchema } from '../-utils/search'

const heatingSearchSchema = z.object({
  chartHistory: z.union([z.literal('roomTemp'), z.literal('heatingCircuits'), z.literal('ecs'), z.literal('production')]).optional(),
})

export type HeatingSearch = z.infer<typeof heatingSearchSchema>

export const Route = createFileRoute('/_dashboard/energy-monitoring/heating/')({
  validateSearch: SearchSchema.merge(heatingSearchSchema),
  async beforeLoad() {
    if (!isUseCase(UseCase.ENERGY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  pendingComponent: PendingComponent,
})
